import {
  CREATE_EVENT_BOOKING_ORDER_REQUEST,
  CREATE_EVENT_BOOKING_ORDER_SUCCESS,
  CREATE_EVENT_BOOKING_ORDER_FAILURE,
  CREATE_EVENT_BOOKING_ORDER_RESET,
} from "../../../types/event"

const initialState = {
  loading: false,
  data: null,
  message: "",
  error: "",
  success: false,
}

const createEventBookingOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_EVENT_BOOKING_ORDER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
        message: "",
        error: "",
        success: false,
      })
    case CREATE_EVENT_BOOKING_ORDER_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        message: action.payload.message,
        error: "",
        success: true,
      })
    case CREATE_EVENT_BOOKING_ORDER_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        message: "",
        error: action.payload.message || action.payload.error,
        success: false,
      })
    case CREATE_EVENT_BOOKING_ORDER_RESET:
      return Object.assign({}, initialState)
    default:
      return state
  }
}

export default createEventBookingOrderReducer
